import { render } from "./LuxAvatar.vue?vue&type=template&id=6d847467&scoped=true&ts=true"
import script from "./LuxAvatar.vue?vue&type=script&lang=ts"
export * from "./LuxAvatar.vue?vue&type=script&lang=ts"

import "./LuxAvatar.vue?vue&type=style&index=0&id=6d847467&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1140266145/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d847467"]])

export default __exports__